export const GET_TICKET_TEMPLATES = "GET_TICKET_TEMPLATES";
export const GET_TICKET_TEMPLATE_BY_ID = "GET_TICKET_TEMPLATE_BY_ID";
export const UPDATE_TICKET_TEMPLATE = "UPDATE_TICKET_TEMPLATE";
export const DELETE_TICKET_TEMPLATE = "DELETE_TICKET_TEMPLATE";
export const CREATE_TICKET_TEMPLATE = "CREATE_TICKET_TEMPLATE";
